angular.module('picmonicng').factory('BrowseService', [
  '$rootScope',
  '$state',
  '$http',
  'UserService',
  '$modalStack',
  'LocalStorageService',
  '$modal',
  '$cookies',
  'PQService',
  function ($rootScope, $state, $http, UserService, $modalStack, LocalStorageService, $modal, $cookies, PQService) {
    //Use extract to remove browse from localStorage after retrevial
    //Returns null if there is no browse in localStorage
    var localStorageBrowseService = LocalStorageService.extractItem('browse');

    var browseRoutes = {
      'home': {
        view: 'browse-container',
        title: 'Home',
        template: '/templates/pages/browse/index.html',
        controller: 'BrowseController',
        url: '/',
        aliases: ['app.pathways.market.home'],
      },
      'app.playlist': {
        view: 'browse-container',
        title: 'Playlist',
        template: '/templates/pages/playlist/index.html',
        controller: 'PlaylistController',
      },
      'app.playlists': {
        view: 'search-container',
        title: 'Playlists',
        secondaryState: true,
        template: '/templates/pages/playlists/browse.html',
      },
      'app.playlists.playlist': {
        view: 'search-container',
        title: 'Playlist',
        secondaryState: true,
        template: '/templates/pages/playlist/index.html',
        controller: 'PlaylistController',
      },
      'app.search': {
        view: 'search-container',
        title: 'Search',
        secondaryState: true,
        template: '/templates/pages/search/index.html',
        controller: 'SearchController',
      },
      'app.pathways.tracks': {
        view: 'browse-container',
        title: 'Tracks',
        template: '/templates/pages/pathways/tracks.html',
        controller: 'PathwaysTracksController',
        aliases: [
          'app.pathways.market.courses.tracks',
          'app.pathways.market.books.tracks',
          'app.pathways.market.boards.tracks',
          'app.pathways.market.first-aid.tracks',
        ],
      },
      'app.pathways.picmonics': {
        view: 'browse-container',
        title: 'Picmonics',
        template: '/templates/pages/pathways/picmonics.html',
        controller: 'PathwaysPicmonicsController',
        aliases: [
          'app.pathways.market.courses.tracks.picmonics',
          'app.pathways.market.books.tracks.picmonics',
          'app.pathways.market.boards.tracks.picmonics',
          'app.pathways.market.first-aid.tracks.picmonics',
        ],
      },
      'app.practice-questions': {
        view: 'search-container',
        title: 'Practice NCLEX&reg; Questions',
        secondaryState: true,
        template: '/templates/pages/browse/browse-practice-questions.html',
        controller: 'BrowsePracticeQuestionsController',
      },
    };
    //hook into the persist event of the storage
    // which will give us an opportunity to do just-in-time synchronization.
    LocalStorageService.onBeforePersist(function handlePersist() {
      LocalStorageService.setItem('browse', BrowseService);
    });

    var BrowseService = {
      browseOpen: false,
      moreMenuOpen: false,
      state: null,
      params: {},
      secondaryState: null,
      secondaryParams: {},
      secondaryVisible: false,
      playlistState: null,
      playlistParams: {},
      previousUrl: '/browse',
      visibleSubPathways: localStorageBrowseService ? localStorageBrowseService.visibleSubPathways : [],
      showVideo: null,
      videos: [
        {
          name: 'Getting Started | Picmonic Learning System',
          youtubeId: 'thycyrWrWno',
          key: 'getting_started',
          link: 'https://www.youtube.com/watch?v=thycyrWrWno',
        },
        {
          name: 'Discover | Searching Picmonics',
          youtubeId: 'MMQDE4i8vM0',
          key: 'discover',
          link: 'https://www.youtube.com/watch?v=MMQDE4i8vM0',
        },
        {
          name: 'Learn with Picmonics | Playlists',
          youtubeId: '7ZmOaH3B-64',
          key: 'playlists',
          link: 'https://www.youtube.com/watch?v=7ZmOaH3B-64',
        },
        {
          name: 'Learn with Picmonics | Spaced Rep',
          youtubeId: '-1xy7mmLsf8',
          key: 'spaced_rep',
          link: 'https://www.youtube.com/watch?v=-1xy7mmLsf8',
        },
      ],
      go: function (state, params, options) {
        var self = this;
        options = options || {};
        var stateChanged = false;
        self.showPQFaqs = false;

        // Find a route matching the current state
        var route = self.getRoute(state);

        // Remember if we were open before we started (for analytics)
        var browseWasOpen = self.browseOpen;

        if (route && route.secondaryState) {
          // If this is a secondary route
          var secondaryWasVisible = self.secondaryVisible;
          self.secondaryVisible = true;
          // If this is a new state
          if (self.secondaryState != state || !_.isEqual(self.secondaryParams, params) || options.force) {
            self.secondaryState = state;
            self.secondaryParams = params;
            stateChanged = true;

            if (state.indexOf('app.playlists') !== -1) {
              self.playlistState = state;
              self.playlistParams = params;
            }

            $rootScope.$broadcast('browseStateChange', {
              state: state,
              route: route,
              params: params,
            });
          }
          this.setOpen(true, false);
        } else if (route) {
          // If this is a primary route
          var secondaryWasVisible = self.secondaryVisible;
          self.closeSecondary();
          var open = true;
          // If this is a new state
          if (self.state != state || !_.isEqual(self.params, params) || options.force) {
            // If we have a new state, change it
            self.state = state;
            self.params = params;
            stateChanged = true;
            $rootScope.$broadcast('browseStateChange', {
              state: state,
              route: route,
              params: params,
            });
          } else {
            // Toggle
            open = !browseWasOpen;
          }

          this.setOpen(open, false);
        } else {
          console.error('Invalid browse state requested: ' + state);
        }

        if (!options || typeof options.history == 'undefined' || options.history) {
          var original_title = document.title;
          document.title = original_title + ' | Browse - ' + route.title;
          window.history.pushState(
            {
              state: state,
              route: route,
              params: params,
              browse: true,
            },
            null,
            window.location.href
          );
          document.title = original_title;
        }

        // Report pageview to analytics -- unless searching
        if (state && stateChanged && state != 'app.search' && state != 'home') {
          if ($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile') !== -1) {
            $rootScope.$apply(function () {
              $rootScope.bodyClass.splice($rootScope.bodyClass.indexOf('nav-browse-hidden-mobile'), 1);
            });
          }
          self.trackPageView(state, route);
        }

        if (state === 'app.practice-questions') {
          self.showPQFaqs = !$cookies.get('pls_user_browse_pq_faqs_hidden') && !PQService.has_tl_access;
          self.showVideo = false;
        } else {
          for (var i = 0; i < self.videos.length; i++) {
            if (
              UserService.user &&
              UserService.user.has_seen &&
              !UserService.user.has_seen['video_' + self.videos[i].key]
            ) {
              self.showVideo = self.videos[i];
              break;
            }
          }
        }
      },
      closeSecondary: function (no_analytics) {
        this.secondaryVisible = false;

        $rootScope.$broadcast('browseVisibilityChange');
      },
      close: function ($event, history) {
        var self = this;
        if (($event && $($event.target).hasClass('browse__overlay')) || !$event) {
          if (typeof history == 'undefined' || history) {
            var original_title = document.title;
            document.title = original_title + ' | Browse';
            window.history.pushState(
              {
                state: 'closed',
                browse: true,
              },
              null,
              window.location.href
            );
            document.title = original_title;
          }
          this.setOpen(false, false);
        }
      },
      setOpen: function (main, moreMenu) {
        var self = this;
        // Set browse open status
        self.browseOpen = main;
        var classIndex = $rootScope.htmlClasses.indexOf('browse--open-html');
        // Add/remove browse--open class to/from HTML tag
        if (main && classIndex == -1) {
          $rootScope.htmlClasses.push('browse--open-html');
        } else if (!main && classIndex != -1) {
          $rootScope.htmlClasses.splice(classIndex, 1);
        }
        // Optionally set more menu status
        if (typeof moreMenu !== 'undefined') {
          self.moreMenuOpen = moreMenu;
        }

        // If the browse tab is open then focus the search input for ADA
        if ($('body').attr('modality') == 'keyboard') {
          if (self.browseOpen) {
            angular.element('#browse-search-input').focus();
          } else {
            angular.element('#navigation-browse-button').focus();
          }
        }
        $rootScope.$broadcast('browseVisibilityChange');
      },
      trackPageView: function (state, route) {
        var self = this;
        var url;
        // Allow a route to manually override the URL
        if (route && route.url) {
          if (typeof route.url == 'function') {
            url = route.url(state, self.params);
          } else {
            url = route.url;
          }
        } else {
          url = $state.href(state, self.params);
        }
        // Default
        if (!url) {
          url = state.replace(/\./g, '/');
        }

        // Send to Analytics
        if (window.pls_config.google_site_id) {
          var path = ('/browse/' + url).replace(/\/\//g, '/');
          gtag('config', window.pls_config.google_site_id, {
            page_path: path,
          });
        }

        // Send to Atlas
        var page_url = ('https:////' + window.location.hostname + '/browse/' + url).replace(/\/\//g, '/');
        $http({
          method: 'POST',
          url: '/api/v2/analytics',
          data: 'action=pageview&source=angular&url=' + page_url + '&referrer=' + self.previousUrl,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
        });
        console.info('Action: pageview | URL: ' + page_url);
        self.previousUrl = page_url;
      },
      toggleOpen: function () {
        var self = this;
        if (this.browseOpen) {
          this.close(false, true);
          return;
        } else {
          this.setOpen(!this.browseOpen, false);
        }

        if (self.browseOpen && !self.state && !self.secondaryVisible) {
          self.go('home');
        } else {
          var original_title = document.title;
          document.title = original_title + ' | Browse';
          window.history.pushState(
            {
              state: BrowseService.state,
              params: BrowseService.params,
              route: BrowseService.getRoute(BrowseService.state),
              browse: true,
            },
            null,
            window.location.href
          );
        }

        // Send analytics
        var event = self.browseOpen ? 'Opened' : 'Closed';
        var secondaryState = self.secondaryState ? self.secondaryState : 'index';
        var eventData = secondaryState && self.secondaryVisible ? secondaryState : self.state ? self.state : 'home';
      },
      toggleMoreMenu: function () {
        this.setOpen(false, !this.moreMenuOpen);
      },
      getRoute: function (state) {
        for (var key in browseRoutes) {
          if (browseRoutes.hasOwnProperty(key)) {
            if (key == state || (browseRoutes[key].aliases && browseRoutes[key].aliases.indexOf(state) !== -1)) {
              return browseRoutes[key];
            }
          }
        }
        return false;
      },
      //Get BrowseService from local storage, use for go requested
      //If not available continue to use home as the go des
      restoreIfNeeded: function () {
        if (localStorageBrowseService && localStorageBrowseService.state) {
          this.go(localStorageBrowseService.state, localStorageBrowseService.params, localStorageBrowseService.options);
        } else {
          this.go('home');
        }
      },
      toggleSubpathwayVisibility: function (pathwayId) {
        if (this.isSubpathwayVisible(pathwayId)) {
          this.visibleSubPathways = this.visibleSubPathways.filter(function (i) {
            return i != pathwayId;
          });
        } else {
          this.visibleSubPathways = [].concat(this.visibleSubPathways, pathwayId);
        }
      },
      isSubpathwayVisible: function (pathwayId) {
        return this.visibleSubPathways.indexOf(pathwayId) !== -1;
      },
      openHowPicmonicWorksModal: function () {
        var self = this;

        send_ga('event', 'Navigation', 'How It Works Modal Open');

        self.modalInstance = $modal.open({
          templateUrl: '/compiled/pillars/research-proven.html',
          windowClass: 'pls-how-it-works-modal',
          backdropClass: 'above-nav',
          controller: [
            '$scope',
            '$compile',
            '$modalInstance',
            function ($scope, $compile, $modalInstance) {
              $scope.inModal = true;
              $modalInstance.result.finally(function () {
                self.modalInstance = null;
              });
            },
          ],
        });
      },
    };

    // Bind window popstate
    window.onpopstate = function (event) {
      $modalStack.dismissAll();

      if (event.state && event.state.browse) {
        if (event.state.state == 'closed') {
          BrowseService.close(false, false);
        } else {
          BrowseService.go(event.state.state, event.state.params, {
            history: false,
          });
        }
      } else {
        BrowseService.close(false, false);
      }
    };

    return BrowseService;
  },
]);
